import { jsx } from "react/jsx-runtime";
const Stylesheet = ({ staging, ...props }) => {
  const domain = staging ? "cdn.zapier-staging.com" : "cdn.zapier.com";
  const build = "2d3ef1d6";
  const url = `https://${domain}/marketing-site-layout/v3/assets/${build}/styles.css`;
  return /* @__PURE__ */ jsx("link", { rel: "stylesheet", href: url, ...props });
};
export {
  Stylesheet
};
